export const Footer = () => (
  <footer className="bg-vg-navy text-white border-t border-white/10" data-testid="footer">
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-8">
      <div className="flex flex-col md:flex-row justify-between gap-4 font-mono-acc text-xs text-[#9ca3af]">
        <p className="normal-case tracking-normal text-[#d1d5db]">
          <span className="text-vg-cyan">© {new Date().getFullYear()} VG Mart.</span> Designed by:
          <span className="text-vg-cyan ml-1">
            <a
              href="https://slc.bz"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              SLC.BZ
            </a>{" "}
            (Laos | Sri Lanka)
          </span>
          . Developed by:
          <span className="text-vg-cyan ml-1">
            <a
              href="https://corebaze.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              CoreBaze
            </a>{" "}
            (Australia).
          </span>
        </p>
        <span className="uppercase tracking-[0.2em] shrink-0">Sokpaluang Road, Vientiane</span>
      </div>
    </div>
  </footer>
);

export default Footer;
